import logoImg from '../../assets/images/logo.png';

export default function Logo({ size = 'md', showText = true, className = '' }) {
  const sizes = { sm: 28, md: 40, lg: 56, xl: 80 };
  const px = sizes[size] || sizes.md;

  return (
    <div className={`elvyra-logo ${className}`} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <img src={logoImg} alt="ELVYRA" width={px} height={px} style={{ objectFit: 'contain' }} />
      {showText && (
        <span style={{
          fontWeight: 700,
          fontSize: px * 0.5,
          color: 'var(--elvyra-accent)',
          letterSpacing: '0.08em',
        }}>
          ELVYRA
        </span>
      )}
    </div>
  );
}
